import { TransactionTable } from "../../../../components/table/Transaction/TransactionTable"

const PlanTransactions = ({ planId } : { planId: string }) => {
    return(<TransactionTable planId={planId} enableExport />)
}

export { PlanTransactions }